import { useCallback } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { setActiveModal } from '../ducks/calendarActions';
import { hasPreSaveInVisibleRange } from '../utils/visibleDates';

export const pendingNavigationRef = { current: null };

const usePreSaveNavigationGuard = () => {
  const dispatch = useDispatch();
  const store = useStore();

  return useCallback((continuation) => {
    if (typeof continuation !== 'function') return;
    if (!hasPreSaveInVisibleRange(store.getState())) {
      continuation();
      return;
    }
    pendingNavigationRef.current = continuation;
    dispatch(setActiveModal('confirmDiscardPreSaveModal', null));
  }, [dispatch, store]);
};

export default usePreSaveNavigationGuard;
